export function formatInZone(epochMs: number, timezone?: string): { hour: string; minute: string } {
  try {
    const formatter = new Intl.DateTimeFormat('en-GB', {
      hour: '2-digit', minute: '2-digit', hour12: false,
      ...(timezone ? { timeZone: timezone } : {}),
    });
    const parts = formatter.formatToParts(new Date(epochMs));
    const hour = parts.find(p => p.type === 'hour')?.value ?? '00';
    const minute = parts.find(p => p.type === 'minute')?.value ?? '00';
    return { hour, minute };
  } catch {
    const date = new Date(epochMs);
    return {
      hour: String(date.getHours()).padStart(2, '0'),
      minute: String(date.getMinutes()).padStart(2, '0'),
    };
  }
}

export function formatDisplayDate(isoDate: string): string {
  try {
    return new Intl.DateTimeFormat('en-GB', { weekday: 'long', day: 'numeric', month: 'long' })
      .format(new Date(isoDate));
  } catch {
    return isoDate;
  }
}
